module.exports = __webpack_public_path__ + "static/media/ANIVERSARIO_xxlarge.2e1ff461.png";